<template>
  <div class="wrapper">
    <div class="title">
      <label>重置密码</label>
      <span>账号申诉成功，请重置密码</span>
    </div>
    <van-form>
      <div>
        <div class="telNum">绑定手机号码后四位{{strTleNo}}</div>
        <van-field 
            v-model="verifyCode" 
            center 
            clearable 
            label="短信验证码" 
            placeholder="请输入短信验证码"
            maxlength="6"
         >
          <template #button>
            <van-button
              size="small"
              type="info"
              @click="sendVerifyCode"
              native-type="button"
              v-if="!isDisabled"
            >{{content}}</van-button>
            <van-button
              size="small"
              type="info"
              native-type="button"
              @click="toastWait"
              v-else
            >{{content}}</van-button>
          </template>
        </van-field>
        <van-field
          v-model="newPwd"
          type="password"
          name="设置新密码"
          label="设置新密码"
          placeholder="数字、字母大小写，不少于8位"
          :rules="[{ required: true, message: '请按规则填写新密码',pattern }]"
        />
        <van-field
          v-model="sureNewPwd"
          type="password"
          name="确认新密码"
          label="确认新密码"
          placeholder="请确认新密码"
          :rules="[{ required: true,pattern,message: ' ' }]"
        />
        <div class="btn-group">
          <van-button type="info" @click="subMitPwd" block>完成</van-button>
        </div>
      </div>
    </van-form>
  </div>
</template>

<script>
import Vue from "vue";
import { mapGetters } from "vuex";
import { Form, Cell, CellGroup } from "vant";
import { Tag } from "vant";
import { Field } from "vant";
import { naturalResetPwd } from "../../api/user";
import checkAJB from "@/utils/checkAlipayJSBridge";
Vue.use(Field);
Vue.use(Tag);
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(Form);
export default {
  data() {
    return {
      userName: "",
      userCardId: "",
      newPwd: "",
      sureNewPwd: "",
      verifyCode: "",
      count: 60,
      content: "发送验证码",
      isDisabled: false,
      sendMessageNo: "",
      timer: null,
      pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[\s\S]{8,30}$/
    };
  },
  computed:{
      ...mapGetters({ getidcard: 'idcard' }),//用户身份证号码
      strTleNo(){ //手机号码后四位
          return this.sendMessageNo.slice(7);
      }
  },
  activated(){
      this.sendMessageNo = this.$route.query.sendMessageNo; //获取手机号码
  },
  methods: {
    toastWait() {
      this.$toast("请" + this.count + "秒后点击获取！");
    },
    sendVerifyCode() {
      naturalResetPwd({
        sendMessageNo: this.sendMessageNo,
        stepNum: "2"
      }).then(res => {
        if (res.respCode === "00000000") {
          this.$toast("已发送验证码至注册手机");
        } else {
          this.$toast(res.respMsg);
        }
      });
      let vm = this;
      // 控制倒计时及按钮是否可以点击
      const TIME_COUNT = 60;
      vm.count = 60;
      vm.leftTime = TIME_COUNT;
      vm.timer = window.setInterval(() => {
        if (vm.count > 0 && vm.count <= TIME_COUNT) {
          // 倒计时时不可点击
          vm.isDisabled = true;
          // 计时秒数
          vm.count--;
          // 更新按钮的文字内容
          vm.content = vm.count + "s后重新获取";
        } else {
          // 倒计时完，可点击
          vm.isDisabled = false;
          // 更新按钮文字内容
          vm.content = "发送验证码";
          // 清空定时器!!!
          clearInterval(vm.timer);
          vm.timer = null;
        }
      }, 1000);
    },
    subMitPwd() {
      let newPwd = this.newPwd;
      let sureNewPwd = this.sureNewPwd;
      if (newPwd != sureNewPwd) {
        console.log(newPwd, sureNewPwd);
        this.$toast("两次密码输入不一致");
        return;
      }
      if (this.verifyCode.length != 6) {
        return this.$toast("请输入6位短信验证码");
      }
      naturalResetPwd({
        useridCardnum: this.getidcard,
        passWord: this.newPwd,
        verifyCode: this.verifyCode,
        stepNum: "3"
      })
    // this.$axios({
    //     url: "/vi/ResetPwd",
    //     method: "post",
    //     data: {
    //             useridCardnum: this.getidcard,
    //             passWord: this.newPwd,
    //             verifyCode: this.verifyCode,
    //             stepNum: "3"
    //         }
    // })
      .then(res => {
        if (res.respCode === "00000000") {
            this.$toast("重置密码成功");
            this.$router.push({ path:'/accountAppeal/success', query:{  
                flag:1
            } });
        } else {
          this.$toast(res.respMsg);
          this.$router.push({ path:"/accountAppeal/error" });
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  background: #f1f2f3;
  .title {
    padding: 15px;
    text-align: left;
    display: flex;
    flex-direction: column;
    label {
      font-size: 25px;
      color: #108ee9;
    }
    span {
      font-size: 12px;
      color: #888888;
      line-height: 25px;
    }
  }
  .custom-value {
    margin-right: 8px;
  }
  .btn-group {
    padding: 15px;
  }
  .telNum {
    padding: 10px;
    font-size: 15px;
    text-align: center;
  }
}
</style>